import { render, staticRenderFns } from "./portfolio.historic.component.vue?vue&type=template&id=1ed5caf5&scoped=true"
import script from "./portfolio.historic.component.vue?vue&type=script&lang=js"
export * from "./portfolio.historic.component.vue?vue&type=script&lang=js"
import style0 from "./portfolio.historic.component.vue?vue&type=style&index=0&id=1ed5caf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5caf5",
  null
  
)

export default component.exports